module.exports = __webpack_public_path__ + "img/icon-add.ad871e13.svg";